import { SlideHeader, StepList } from "../shared";

export function Slide16Going() {
  const STEPS = [
    { title: "Sense", desc: "UV, heat, humidity and activity." },
    { title: "Understand", desc: "Routines, context and formulation use." },
    { title: "Prompt", desc: "Tells you when it is time to apply." },
    { title: "Act", desc: "One press, already on the wrist." },
    { title: "Learn", desc: "Patterns improve over time." },
  ];
  const APPLICATIONS = [
    "Medical Aesthetics & Dermatology",
    "Consumer Skincare",
    "Healthcare & Sanitization",
    "Personal Protection",
    "Global Health",
  ];
  return (
    <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-start max-w-5xl" data-testid="pitch-slide-going">
      <div>
        <SlideHeader n="17" label="Where It's Going" />
        <h2 className="font-heading text-3xl sm:text-4xl md:text-5xl font-light tracking-tighter leading-[1.08] text-white">
          AI that does not stop at <span className="text-accent">the recommendation.</span>
        </h2>
        <p className="font-body text-zinc-400 text-base md:text-lg leading-relaxed mt-5 max-w-lg">
          It helps turn the recommendation into action.
        </p>
        <StepList testid="pitch-going-steps" steps={STEPS} />
      </div>
      <div className="flex flex-col gap-8">
        <div
          className="flex flex-col gap-2.5 border border-zinc-800 rounded-xl px-6 py-5 bg-white/[0.02] max-w-xs"
          data-testid="pitch-going-applications"
        >
          <p className="font-mono text-[10px] tracking-[0.15em] uppercase text-accent">One Platform, Five Opportunities</p>
          {APPLICATIONS.map((a) => (
            <div key={a} className="flex items-start gap-2.5">
              <span className="w-1 h-1 rounded-full bg-accent mt-2 shrink-0" />
              <p className="font-body text-zinc-300 text-sm leading-relaxed">{a}</p>
            </div>
          ))}
        </div>
        <p className="font-heading text-2xl sm:text-3xl font-light tracking-tight leading-snug text-white max-w-md">
          The next generation of personal care will not simply understand what your skin needs.{" "}
          <span className="text-accent">It will help make sure the product is there when you need it.</span>
        </p>
      </div>
    </div>
  );
}
